import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Translate } from '@mui/icons-material';
import { Select, Option } from '@cnx-saas/common-fe';
import { UserLanguages } from '@cnx-saas/common';

const languages = [
  { label: 'English', value: UserLanguages.GB },
  { label: 'Deutsch', value: UserLanguages.DE },
  { label: 'Polskie', value: UserLanguages.PL },
];

const SelectWrapper = styled.div`
  width: 40%;
`;

function LanguagePicker() {
  const { i18n } = useTranslation();

  const storedLanguageOption = languages.find(
    ({ value }) => value === localStorage.getItem('i18nextLng')?.toUpperCase(),
  );
  const [englishLanguageOption] = languages;
  const [selectedLanguage, setSelectedLanguage] = useState<Option<string>>(
    storedLanguageOption ?? englishLanguageOption,
  );

  function handleChangeLanguage(option: Option<string>) {
    setSelectedLanguage(option);
    void i18n.changeLanguage(
      option.value === UserLanguages.GB
        ? 'en'
        : option.value.toLocaleLowerCase(),
    );
  }
  return (
    <SelectWrapper>
      <Select
        startIcon={<Translate />}
        selectedOption={selectedLanguage}
        options={languages}
        onSingleSelect={handleChangeLanguage}
      />
    </SelectWrapper>
  );
}

export { LanguagePicker };
